import { render, staticRenderFns } from "./EditorShell.vue?vue&type=template&id=12e22e73&scoped=true"
import script from "./EditorShell.vue?vue&type=script&lang=js"
export * from "./EditorShell.vue?vue&type=script&lang=js"
import style0 from "./EditorShell.vue?vue&type=style&index=0&id=12e22e73&prod&scoped=true&lang=css"
import style1 from "./EditorShell.vue?vue&type=style&index=1&id=12e22e73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e22e73",
  null
  
)

export default component.exports